export enum ResourceLoadState {
  INITIAL = 'Initial',
  LOADING = 'Loading',
  LOAD_SUCCESSFUL = 'Load Successful',
  LOAD_FAILURE = 'Load Failure',
}
